<template>
  <RouterView />
</template>

<style>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --navy:       #0f264f;
  --navy-deep:  #091a38;
  --navy-mid:   #1a3a6e;
  --periwinkle: #becdea;
  --steel:      #7a96c1;
  --pale:       #e1ecff;
  --off-white:  #f5f8ff;
  --white:      #ffffff;
  --text-body:  #2c3e5c;
  --text-muted: #6b82a0;
}

html { scroll-behavior: smooth; }
body { font-family: 'Inter', sans-serif; background: var(--off-white); color: var(--text-body); overflow-x: hidden; }

.reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.65s cubic-bezier(.4,0,.2,1), transform 0.65s cubic-bezier(.4,0,.2,1); }
.reveal.visible { opacity: 1; transform: none; }
.reveal-delay-1 { transition-delay: 0.1s; }
.reveal-delay-2 { transition-delay: 0.2s; }
.reveal-delay-3 { transition-delay: 0.3s; }
.reveal-delay-4 { transition-delay: 0.4s; }

@media (prefers-reduced-motion: reduce) {
  *, .coming-soon-badge, .hero-headline, .hero-sub, .hero-actions { animation: none !important; transition: none !important; opacity: 1 !important; transform: none !important; }
  .reveal { opacity: 1; transform: none; }
}
</style>
